module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep1-e7d0e25317f8eb07df0dba325218ed7d.wav";